import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useStateList } from './HandleInvoiceStateProvider';

export function useHandleTaxabilityChange({
  Type
}) {

    const {setItems,setNonItems,partyType,setCompanyState,setData,data,totNetAmt,items,nonItems}=useStateList();
     const getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
      const companyType = getCompany?.relatedcompanydetailsnew?.[0].registrationtype;
      const companyState = getCompany?.relatedaddressentity?.[0]?.statecode;
  const handleTaxabilityChange = useCallback(
    (newValue) => {
      if (newValue === '') {
        setData((prev) => ({
          ...prev,
          errorStatus: {
            ...prev.errorStatus,
            taxability: true,
          },
          errorFields: {
            ...prev.errorFields,
            taxability: 'Taxability is required',
          },
        }));
        return;
      }

      if (newValue?.value == 6 && data?.partyCategory === 'SEZ') {
        setCompanyState('');
      } else {
        setCompanyState(companyState);
      }

      setData((prev) => ({
        ...prev,
        reverseChargeFlag: newValue?.value === 4 ? 1 : 0,
      }));

      if (totNetAmt) {
        // Update Items
        let updatedItems = [...items];

        updatedItems = updatedItems.map((ele) => ({
          ...ele,
          originalGSTRate: ele.GSTRate,
          originalCessRate:ele?.cessRate,
          originalIGST: ele.IGST,
          originalGSTCess: ele.GSTCess,
          originalNetAmt: companyType === 3 && partyType === 'CUSTOMER' ? ele.taxableAMount : ele.netAmount, //LEDX-4673
          originalTaxAmt: ele.taxableAMount,
        }));

        updatedItems = updatedItems.map((ele) => {
          if (newValue.value === 4 && (partyType === 'CUSTOMER' || Type === 'Pos')) {
            let igstAmt = 0;
            let cessAmt=0;
            if(Number(ele.GSTRate)>0){
            igstAmt = (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100;
            igstAmt = Number(igstAmt) / 2;
            igstAmt = Math.round(igstAmt * 100) / 100;
            igstAmt = igstAmt * 2;
            }
            //LEDX-5418
              if(Number(ele.cessRate)>0){
            cessAmt = (Number(ele.taxableAMount) * Number(ele.cessRate)) / 100;
          
            }
            return {
              ...ele,
              IGST: igstAmt,
              // GSTCess: ele.originalGSTCess,
              GSTCess:cessAmt,//LEDX-5418
              netAmount: ele.taxableAMount,
            };
          } else if ([2, 3, 5, 7, 9].includes(newValue.value)) {
            return {
              ...ele,
              IGST: 0,
              GSTCess: 0,
              netAmount: ele.taxableAMount,
            };
          } else {
            let igstAmt = 0;
            let cessAmt=0;
              if(Number(ele.originalGSTRate)>0){
            igstAmt = (Number(ele.originalTaxAmt) * Number(ele.originalGSTRate)) / 100;
            igstAmt = Number(igstAmt) / 2;
            igstAmt = Math.round(igstAmt * 100) / 100;
            igstAmt = igstAmt * 2;
              }
              //LEDX-5418
               if(Number(ele.originalCessRate)>0){
            cessAmt = (Number(ele.originalTaxAmt) * Number(ele.originalCessRate)) / 100;
          
            }
            return {
              ...ele,
              IGST: igstAmt,
              GSTCess:cessAmt,
              GSTRate: ele.originalGSTRate,
              cessRate:ele.originalCessRate,
              // GSTCess: ele.originalGSTCess,
              //LEDX-5418
              taxableAMount: ele.originalTaxAmt,
              netAmount:
                //LEDX-4673
                companyType === 3 && partyType === 'CUSTOMER'
                  ? Number(ele.originalTaxAmt)
                  : Number(ele.originalTaxAmt) +
                  //  Number(ele.originalGSTCess)
                  Number(cessAmt) //LEDX-5418
                    + 
                   igstAmt,

            };
          }
        });

        // Update Non-Items
        let updatedNonItems = [...nonItems];
        updatedNonItems = updatedNonItems.map((ele) => ({
          ...ele,
          originalGSTRate: ele.GSTRate,
          originalCessRate: ele.cessRate,
          originalIGST: ele.IGST,
          originalGSTCess: ele.GSTCess,
          originalNetAmt: companyType === 3 && partyType === 'CUSTOMER' ? ele.taxableAMount : ele.netAmount, //LEDX-4673
          originalTaxAmt: ele.taxableAMount,
        }));

        updatedNonItems = updatedNonItems.map((ele) => {
          if (newValue.value === 4 && (partyType === 'CUSTOMER' || Type === 'Pos')) {
            let igstAmt = 0;
            let cessAmt=0;
            if( Number(ele.GSTRate)>0){
            igstAmt = (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100;
            igstAmt = Number(igstAmt) / 2;
            igstAmt = Math.round(igstAmt * 100) / 100;
            igstAmt = igstAmt * 2;
            }
             //LEDX-5418
              if(Number(ele.cessRate)>0){
            cessAmt = (Number(ele.taxableAMount) * Number(ele.cessRate)) / 100;
          
            }
            return {
              ...ele,
              IGST: igstAmt,
              // GSTCess: ele.originalGSTCess,
              GSTCess: cessAmt,//LEDX-5418
              netAmount: ele.taxableAMount,
            };
          } else if ([2, 3, 5, 7, 9].includes(newValue.value)) {
            return {
              ...ele,
              IGST: 0,
              GSTCess: 0,
              netAmount: ele.taxableAMount,
            };
          } else {
            let igstAmt = 0;
            let cessAmt=0;
            if( Number(ele.GSTRate)>0){
            igstAmt = (Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100;
            igstAmt = Number(igstAmt) / 2;
            igstAmt = Math.round(igstAmt * 100) / 100;
            igstAmt = igstAmt * 2;
            }
             //LEDX-5418
              if(Number(ele.cessRate)>0){
            cessAmt = (Number(ele.originalTaxAmt) * Number(ele.cessRate)) / 100;
          
            }
            return {
              ...ele,
              IGST: igstAmt,
              GSTRate: ele.originalGSTRate,
              cessRate: ele.originalCessRate,
              // GSTCess: ele.originalGSTCess,
              GSTCess:cessAmt,//LEDX-5418
              taxableAMount: ele.originalTaxAmt,
              netAmount:
                //LEDX-4673
                companyType === 3 && partyType === 'CUSTOMER'
                  ? Number(ele.originalTaxAmt)
                  : Number(ele.originalTaxAmt) +
                  //  Number(ele.originalGSTCess)
                  Number(cessAmt) //LEDX-5418
                    + igstAmt,
            };
          }
        });

        setItems(updatedItems);
        setNonItems(updatedNonItems);
      }

      setData((prev) => ({
        ...prev,
        taxability: newValue,
        errorStatus: {
          ...prev.errorStatus,
          taxability: false,
        },
        errorFields: {
          ...prev.errorFields,
          taxability: '',
        },
      }));
    },
    [
      data?.partyCategory,
      companyState,
      totNetAmt,
      companyType,
      partyType,
      Type,
      setItems,
      setNonItems,
      setCompanyState,
      setData,
    ]
  );

  return handleTaxabilityChange;
}
